import { ContattoDTO } from "./contatto-dto";

export class DomicilioDTO {
	idDomicilioSelezionato: string;
	contatto: ContattoDTO;
	hasSelezionatoDomicilio: Boolean;
}